<template>
    <v-card height="100px" class="elevation-4">
        <v-col>
            <img src="../../assets/gfiMSME.png" class="productImageSize" alt="logo"/>
        </v-col>
    </v-card>
</template>
<script>
    export default {
        name: "Header"
    }
</script>

<style>
.productImageSize {
    max-height: 90px;
}
</style>
